<!-- @format -->

<app-cart-container [pageTitle]="pageTitleKey">
  <sis-wizard-progress [stepKeys]="wizardStepKeys" [currentStep]="currentStep" />
  <ng-content></ng-content>
</app-cart-container>
